import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderFatal = (msg) => root.render(
  <div style={{ fontFamily: "system-ui", padding: 32, maxWidth: 640 }}>
    <h1 style={{ fontSize: 18, margin: 0 }}>ShotConnect Web cannot start</h1>
    <p style={{ color: "#666", fontSize: 14 }}>{msg}</p>
  </div>
);

// Runtime config is loaded before the app bundle evaluates so src/config.js can read it synchronously.
fetch(`/shotconnect.config.json?v=${Date.now()}`, { cache: "no-store" })
  .then((r) => (r.ok ? r.json() : {}))
  .catch(() => ({}))
  .then((cfg) => { window.__SHOTCONNECT_CONFIG__ = cfg || {}; return import("@/App"); })
  .then(({ default: App }) => root.render(<React.StrictMode><App /></React.StrictMode>))
  .catch((e) => renderFatal(e.message));
